import React, { useEffect, useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FormGroup, Label, Form, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import $ from 'jquery';
import moment from 'moment';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';
import { parseValue } from '../utils/Common';
import Table from './common/Table';

const common = require('../utils/Common');
const envConfig = require('../config/envConfig');

const Buyers = () => {
    let navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [buyersData, setBuyersData] = useState([]);
    const [walletData, setWalletData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});
    const [page, setPage] = useState(1);
    
    const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
    
    const getBuyers = async ( limit = 10, offset = 0, search = {}, loader = true, reset = false, isExport = 0) => {
        if (reset) {
            setPage(1);
            offset = 0;
        } else {
            setPage(offset / limit + 1);
        }
        const currentStartDate = $('#Date-from').val() || startDate;
        const currentEndDate = $('#Date-to').val() || endDate;

        setStartDate(currentStartDate);
        setEndDate(currentEndDate);

        let data = {
            "user_type": 'buyer',
            'fromDate': currentStartDate,
            'toDate': currentEndDate,
            'limit': limit,
            'offset': offset,
            'export': isExport
        }
        let response = await common.apiRequest('post', '/admin/get-sellers-users-data', data, loader);
        if (response.status == 200) {
            if (response.data.code == 'success') {
                if (isExport) {
                    return response.data.data;
                }
                setBuyersData(response.data.data);
                setTotalRecords(response.data.totalRecords);
            } else {
                alert(response.data.error);
            }
        } else {
            alert(response.data.error);
        }
    }
    const movePage = (path, data) => {
        const startDateValue = $('#Date-from').val() || startDate;
        const endDateValue = $('#Date-to').val() || endDate;
              
        navigate(path, { state: {
            id: data,
            startDate: startDateValue,
            endDate: endDateValue,
        }});
    }

    const handleShowModal = (user) => {
        setSelectedUser(user);
        setShowModal(true);
    };
    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedUser(null);
    };

    useEffect(() => {
        checkAccess();
    }, []);

    const checkAccess = async () => {
        let rights = await common.checkAccessRights(window.location.pathname);
        if (!rights.view) {
            alert("Access Denied");
            navigate("/");
            return;
        } else {
            setUserRights(rights);
            if (!localStorage.getItem('admin_token')) {
                navigate('/login');
            }
            getBuyers();
        }
    }
    const handleAccept = async (id) => {
        const data = {
            action: "update",
            id: id,
            pan_status: "1",
            user_type: 'buyer'
        };
        try {
            let response = await common.apiRequest('post', '/admin/crud-pan-status', data);
            if (response.data.code === "success") {
                alert(response.data.message);
            } else {
                alert(response.data.error);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } handleCloseModal();
        handleCloseModal();
    };

    const handleReject = async (id) => {
        const data = {
            action: "update",
            id: id,
            pan_status: "2",
            user_type: 'buyer'
        };
        try {
            let response = await common.apiRequest('post', '/admin/crud-pan-status', data);
            if (response.data.code === "success") {
                alert(response.data.message);
            } else {
                alert(response.data.error);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } handleCloseModal();
    };
    const handleActive = async (user) => {
        const data = {
            action: "updateActive",
            id: user.id,
            'active': user.active ? 0 : 1,
            "user_type": 'buyer'
        };

        try {
            let response = await common.apiRequest('post', '/admin/get-sellers-users-data', data);
            if (response.data.code === "success") {
                alert(response.data.message);
                getBuyers(10, (page - 1) * 10, {}, true, false)
            } else {
                alert(response.data.error);
            }
        } catch (error) {
            console.error('Error updating user status:', error);
        }
    };

    const showOrderTrackings = async (id) => {
        var parameters = {
            'user_id': id,
            'start_date': $('#Date-from').val(),
            'end_date': $('#Date-to').val(),
        }
        let response = await common.apiRequest('post', '/users/get-wallet-data', parameters);
        let data = (response.data && response.data.data) ? response.data.data : [];
        setWalletData(data);
        setOrderTrackings(!orderTrackings);
    }
    const [orderTrackings, setOrderTrackings] = useState(false);
    const  walletdata = walletData.map((data, index) => {
        return {
            "S. No.": index + 1,
            "Transaction Date": moment(data.created_at).format('YYYY-MM-DD HH:mm:ss'),
            "Type": data?.type || 'N/A',
            "Order ID": data?.order_item?.order?.order_id || 'N/A',
            "Credit": common.parseValue(data.credit, 'float'),
            "Debit": common.parseValue(data.debit, 'float'),
            "Balance": common.parseValue(data.balance, 'float'),
            "Withdrawal Status": data?.withdrawl_status == 1 
                ? 'Request Sent' 
                : data?.withdrawl_status == 2 
                ? 'Approved' 
                : 'NA',
            "Withdrawal Approved Date": data?.withdrawl_approved_date || 'NA',
            "Payment Date": data?.payment_date || 'NA',
        };
    });
    
    const handleWalletExportCSV = () => {
        exportToCSV(walletdata, 'Wallet');
    }
    
    const handleWalletExportExcel = () => {
        exportToExcel(walletdata, 'Wallet');
    }
    
    const handleWalletExportPDF = () => {
        exportToPDF(walletdata, 'Wallet');
    }
    const columns = [
        { header: "User Id", accessor: "reg_id" },
        { header: "First Name", accessor: "first_name" },
        { header: "Middle Name", accessor: "middle_name" },
        { header: "Last Name", accessor: "last_name" },
        {
            header: "Wallet",
            accessor: "wallet_tracking",
            render: (row) => (
            <button
                type="button"
                className="form-control btn btn-info"
                onClick={() => showOrderTrackings(row?.id)}
            >
                View Wallet Trackings
            </button>
            ),
        },
        { header: "Service Vendor Business Name", accessor: "seller_business_name" },
        { header: "PAN No", accessor: "pan_no" },
        { header: "GST No", accessor: "gst_no" },
        {
            header: "Total Purchases",
            accessor: "totalPurchases",
            render: (row) => parseValue(Number(row.totalPurchases) || 0, 'float'),
        },
        { header: "Email", accessor: "email" },
        { header: "Mobile Phone", accessor: "mobile_phone" },
        { header: "Bank Account No", accessor: "bank_account_no" },
        { header: "Bank Name", accessor: "bank_name" },
        { header: "IFSC Code", accessor: "ifsc_code" },
        { header: "Nominee Name", accessor: "nominee_name" },
        { header: "Referred By", accessor: "referrerBY" },
        { header: "Address", accessor: "user_address" },
        { header: "Point of Contact", accessor: "seller_Point_Contact" },
        {
            header: "Referred User Data",
            accessor: "referredUserData",
            render: (row) => (
            <Link to="/user-refeance-details" state={{ userId: row.id }}>
                View reffer
            </Link>
            ),
        },
        {
            header: "Orders",
            accessor: "orders",
            render: (row) => (
            <Button color="primary" size="sm" onClick={() => movePage('/buyer-orders', row.id)}>
                All Orders
            </Button>
            ),
        },
        {
            header: "Pan Image",
            accessor: "panImage",
            render: (row) => (
            <Button color="primary" onClick={() => handleShowModal(row)}>
                View Image
            </Button>
            ),
        },
        {
            header: "Active Status",
            accessor: "activeStatus",
            render: (row) => (row.active ? "Active" : "Not Active"),
        },
        {
            header: "Active/Inactive",
            accessor: "toggleActive",
            render: (row) => (
            <Button onClick={() => handleActive(row)} className="submit">
                {row.active ? "Deactivate" : "Activate"}
            </Button>
            ),
        },
    ];


    const data = buyersData.map((item, index) => ({
        "S.no": index + 1,
        "User Id": item.reg_id || "N/A",  
        "First Name": item.first_name || "N/A",  
        "Middle Name": item.middle_name || "N/A",
        "Last Name": item.last_name || "N/A",  
        "Service Vendor Business Name": item.seller_business_name || "N/A",  
        "PAN No": item.pan_no || "N/A",  
        "GST No": item.gst_no || "N/A",  
        "Total Shopping Amount": item.totalPurchases || 0,  
        "Total Sales Amount": item.totalSales || 0,  
        "Email": item.email || "N/A",  
        "Mobile Phone": item.mobile_phone || "N/A",  
        "Bank Account No": item.bank_account_no || "N/A",  
        "Bank Name": item.bank_name || "N/A",  
        "IFSC Code": item.ifsc_code || "N/A",  
        "Nominee Name": item.nominee_name || "N/A",  
        "Referred By": item.referrerBY || "N/A",  
        "Address": item.user_address || "N/A",  
        "Point of Contact": item.seller_Point_Contact || "N/A",  
    }));


    const handleExportCSV = async () => {
        let data = await getBuyers(10, 0, {}, true, false, 1);
        exportToCSV(data, 'All Buyer');
    }

    const handleExportExcel = async () => {
        let data = await getBuyers(10, 0, {}, true, false, 1);
        exportToExcel(data, 'All Buyer');
    }

    const handleExportPDF = async () => {
        let data = await getBuyers(10, 0, {}, true, false, 1);
        exportToPDF(data, 'All Buyer');
    }

    const handleDateChange = (e) => {
        if (e.target.id === "Date-from") {
        setStartDate(e.target.value);
        } else if (e.target.id === "Date-to") {
        setEndDate(e.target.value);
        }
        getBuyers();
    };

    return (
        <>
            <h1>All Buyers</h1><br />
            <div className="col-md-12">
                <Form className='row'>
                    <FormGroup className='col-md-4 row'>
                        <Label className="col-md-2 col-form-label" for="Date-from">From:</Label>
                        <Input type='date' 
                            value={startDate}
                            onChange={handleDateChange}
                        className="form-control col-md-5" id="Date-from" name="Date-from"></Input>
                    </FormGroup>
                    <FormGroup className='col-md-4 row'>
                        <Label className="col-md-2 col-form-label" for="Date-to">To:</Label>
                        <Input type='date' 
                            value={endDate}
                            onChange={handleDateChange}
                        className="form-control col-md-5" id="Date-to" name="Date-to"></Input>
                    </FormGroup>
                </Form>
                <button className='btn button-product' onClick={handleExportCSV}>Export to CSV</button>
                        <button className='btn button-product' onClick={handleExportExcel}>Export to Excel</button>
                        <button className='btn button-product' onClick={handleExportPDF}>Export to PDF</button>
            </div>
            <div className="ag-theme-quartz" style={{ height: 600, width: '100%' }}>
                <Table
                    columns={columns}
                    data={buyersData}
                    totalRecords={totalRecords}
                    pageSize={10}
                    currentPage={page}
                    onPageChange = {(limit, offset, search, reset) =>{
                        getBuyers(limit, offset, search, true, reset);
                    }}
                />
            </div>
            <Modal isOpen={showModal} toggle={handleCloseModal}>
                <ModalHeader toggle={handleCloseModal}>User PAN Image</ModalHeader>
                <ModalBody>
                    {selectedUser && selectedUser.user_pan_image && (() => {
                        const fileUrl = envConfig.api_url + selectedUser.user_pan_image;
                        const isPdf = fileUrl.toLowerCase().endsWith('.pdf');

                        return isPdf ? (
                        <iframe
                            src={`https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`}
                            style={{ width: '100%', height: '500px' }}
                            title="User PAN PDF"
                        />
                        ) : (
                        <img
                            src={fileUrl}
                            style={{ width: '100%', height: 'auto' }}
                            alt="User PAN"
                        />
                        );
                    })()}
                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={() => handleAccept(selectedUser.id)}>
                        Accept
                    </Button>
                    <Button color="danger" onClick={() => handleReject(selectedUser.id)}>
                        Reject
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={orderTrackings} toggle={() => showOrderTrackings(0)} size="lg">
            <ModalHeader toggle={() => showOrderTrackings(0)}>Wallet Trackings</ModalHeader>
            <ModalBody>
            <div className="container-fluid">
                    <div className="col-md-12">
                            <Form className='row'>
                                <FormGroup className='col-md-4 row'>
                                    <Label className="col-md-2 col-form-label" for="Date-from">From:</Label>
                                    <input type='date' defaultValue={moment().startOf('month').format('YYYY-MM-DD')} onChange={showOrderTrackings} className="form-control col-md-5" id="Date-from" name="Date-from"></input>
                                </FormGroup>
                                <FormGroup className='col-md-4 row'>
                                    <Label className=" col-md-2 col-form-label" for="Date-to">To:</Label>
                                    <input type='date' defaultValue={moment().endOf('month').format('YYYY-MM-DD')} onChange={showOrderTrackings} className="form-control col-md-5" id="Date-to" name="Date-to"></input>
                                </FormGroup>
                            </Form>       
                            <div>
                    <button className='btn button-product' onClick={handleWalletExportCSV}>Export to CSV</button>
                    <button className='btn button-product' onClick={handleWalletExportExcel}>Export to Excel</button>
                    <button className='btn button-product' onClick={handleWalletExportPDF}>Export to PDF</button>

                </div>
                    
                        </div>
                    <div className='row'>
                    <div className='col-md-12 table-responsive table-container'>
                        <table striped bordered hover>
                            <thead>
                                <tr>
                                <th>Transaction Date</th>
                                <th>Type</th>
                                <th>Order Id</th>
                                <th>Credit</th>
                                <th>Debit</th>
                                <th>Balance</th>
                                <th>Withdrawl Status</th>
                                <th>Withdrawl Approved Date</th>
                                <th>Payment Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    walletData.map((data) => {
                                        return (
                                            <tr>
                                                <td>{moment(data.created_at).format('YYYY-MM-DD HH:mm:ss')}</td>
                                                <td>{data?.type || null}</td>
                                                {
                                                    data?.order_item?.order?.order_id ? 
                                                    <td style={{ cursor: 'pointer', color: 'blue' }} onClick={() => navigate(`/orders/${data?.order_item?.order?.order_id || null}`)}>
                                                        {data?.order_item?.order?.order_id || 'NA'}
                                                    </td>
                                                    : <td>NA</td>
                                                }
                                                <td>{common.parseValue(data.credit,'float')}</td>
                                                <td>{common.parseValue(data.debit,'float')}</td>
                                                <td>{common.parseValue(data.balance, 'float')}</td>
                                                <td>{data?.withdrawl_status == 1 ? 'Request Sent' : data?.withdrawl_status == 2 ? 'Approved' : 'NA'}</td>
                                                <td>{["1", "2"].includes(data?.withdrawl_status) ? data?.withdrawl_approved_date || 'Yet to be updated' : 'NA'}</td>
                                                <td>{["1", "2"].includes(data?.withdrawl_status) ? data?.payment_date || 'Yet to be updated' : 'NA'}</td>
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>
                        </table>       
                    </div>
                    </div>
                </div>
            </ModalBody>
            </Modal>
        </>
    )
}

export default Buyers;